export enum MandatoryStatusEnum {
  AUTO = -1,
  NO = 0,
  YES = 1
}